import React from 'react';
import { Chip, Typography } from '@mui/material';
import { capitalize } from '@mui/material';

interface Props {
  changeType: string;
}

const formatChangeType = (value: string): string => {
  return value
    .split('_')
    .map(word => capitalize(word.toLowerCase()))
    .join(' ');
};

export const ChangeTypeChip = ({ changeType }: Props) => {
  return <Chip size="small" color="primary" label={<Typography>{formatChangeType(changeType)}</Typography>} />;
};
